var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11544_1872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2583 15.026L10.0174 18.2669M10.1393 18.4886L12.8733 23.9743C13.0881 24.4053 13.1955 24.6208 13.3337 24.6814C13.4537 24.7341 13.5915 24.7272 13.7057 24.6628C13.8372 24.5887 13.9226 24.3636 14.0933 23.9134L19.5094 9.63476C19.6761 9.19531 19.7594 8.97558 19.7115 8.83402C19.6699 8.71103 19.5733 8.61446 19.4503 8.57285C19.3088 8.52496 19.0891 8.6083 18.6496 8.77499L4.36602 14.1929C3.91716 14.3632 3.69273 14.4483 3.61861 14.5796C3.55425 14.6936 3.5472 14.8312 3.59958 14.9512C3.65989 15.0893 3.87444 15.1969 4.30356 15.4122L9.84156 18.19C9.91526 18.227 9.95211 18.2455 9.98403 18.2702C10.0124 18.2921 10.0377 18.3175 10.0596 18.3459C10.0842 18.3779 10.1025 18.4148 10.1393 18.4886Z",
    stroke: "#F7665F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11544_1872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 14.1426) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRedArrow);
export default __webpack_public_path__ + "static/media/AlertRedArrow.7efe852bd8d4ba5a33aee9da609986a1.svg";
export { ForwardRef as ReactComponent };